import { NotificationsStatusEnum } from 'interfaces/enums';

export const friendlyLabels = {
  accountsAddress: 'Addresses',
  accountsSubscription: 'Subscriptions',
  accountsSubscriptions: 'Subscriptions',
  paidEmissionLibraries: 'Paid Emission Libraries',
  contactsRole: 'Accounts/Contacts',
  channelRules: 'Channel Rules',
  channelJobs: 'Channel Jobs',
  consumptionJobs: 'Consumption Jobs',
  feedsConfigModbus: 'Feeds Config Modbus',
  feedsConfigBacNet: 'Feeds Config BacNet',
  feedsLogs: 'Feeds Logs',
  emissions: 'Emission Factor Libraries',
  channelsMappings: 'Channels Mappings',
  weatherReadings: 'Weather Readings',
};

export const typeObj = {
  0: 'unknown',
  1: 'dashboard',
  2: 'group',
  3: 'site',
  4: 'building',
  5: 'load',
  6: 'channel',
  7: 'channelCalc',
};

export const utilityObj = {
  0: null,
  1: 'electricity',
  2: 'water',
  3: 'gas',
  4: 'production',
  5: 'heat',
  6: 'steam',
  7: 'weather',
  8: 'enviromental',
  9: 'ghgEmmisions',
  10: 'other',
};

export const utilityObjRev = {
  electricity: 1,
  water: 2,
  gas: 3,
  production: 4,
  heat: 5,
  steam: 6,
  weather: 7,
  enviromental: 8,
  ghgEmmissions: 9,
  other: 10,
};

export const typeObjRev = {
  unknown: 0,
  dashboard: 1,
  group: 2,
  site: 3,
  building: 4,
  load: 5,
  channel: 6,
};

export const intervalObj = {
  None: 0,
  Yearly: 1,
  Months: 2,
  Weeks: 3,
  Days: 4,
  Hours: 5,
  HalfHourly: 6,
  Minutes: 7,
  LooseFrequency: 8,
};

export const intervalObjRev = {
  0: 'N/A',
  1: 'Yearly',
  2: 'Monthly',
  3: 'Weekly',
  4: 'Daily',
  5: 'Hourly',
  6: 'Half Hourly',
  7: '15 Minutes',
  8: 'LooseFrequency',
};

export const voltTypes = ['L1V', 'L2V', 'L3V', 'VoltsA', 'VoltsB', 'VoltsC'];

export const ampTypes = ['L1A', 'L1A Max', 'L2A', 'L2A Max', 'L3A', 'L3A Max'];

export const voltAmpTypes = ampTypes.concat(voltTypes);

export const mlQualificationStatusTypes = [
  'TO_BE_REVIEWED',
  'TO_INVESTIGATE_LATER_BY_ESP',
  'DISQUALIFIED_BY_ESP',
  'QUALIFIED_NOT_ESCALATED',
  'QUALIFIED_BY_ESP',
  'UNDER_INVESTIGATION_BY_CUSTOMER',
  'PENDING_ACTION',
  'QUALIFIED_BY_CUSTOMER',
  'DISQUALIFIED_BY_CUSTOMER',
];

export const actionTypes = {
  0: 'Investigate',
  1: 'Repair',
  2: 'Replace',
  3: 'Tell me more',
  4: 'Get a quote',
  5: 'Known Issue',
  6: 'Expected Change',
  7: 'Not Relevant',
};

export const intervalMins = [1, 5, 10, 15, 30, 60, 1440, 10080, 10080, 43920, 0];

export const intervalFrequency = [
  '1 minute',
  '5 minute',
  '10 minute',
  '15 minute',
  '30 minute',
  '60 minute',
  'Daily',
  'Weekly Starting Monday',
  'Weekly Starting Sunday',
  'Monthly',
  'LooseFrequency',
];

export const supportedTimeZones = {
  'UTC +12': 'UTC +12 (New Zealand)',
  'NZST/NZDT': 'NZST/NZDT (New Zealand)',
  AWST: 'AWST (Perth, Australia)',
  ACWST: 'ACWST (Eucla, Australia)',
  ACST: 'ACST (Darwin, Australia)',
  AEST: 'AEST (Brisbane, Australia)',
  'ACDT/ACST': 'ACDT/ACST (Adelaide, Australia)',
  'AEDT/AEST': 'AEDT/AEST (Sydney, Australia)',
  'LHDT/LHST': 'LHDT/LHST (Lord Howe Island, Australia)',
};

export const industryCodes = [
  null,
  '',
  'Accommodation & Entertainment',
  'Broadcasting Printing and Publishing',
  'Commercial Property - Owners/Managers',
  'Cool-stores',
  'Entertainment Retail',
  'Food and Tobacco Processing',
  'Food & Beverage Production',
  'Health & Education',
  'Industrial & Manufacturing',
  'Misc.',
  'Not for Profit',
  'Public Sector - Central Govt',
  'Public Sector - Health & Education',
  'Public Sector - Local Govt',
  'Retail Property',
  'test',
  'test2',
  'Transport',
];

export const meterTypes = [null, '', 'ESP Meter', 'Existing', 'Not Metered', 'test', 'Virtual Meter'];

export const communicationTypes = [null, '', 'Modbus', 'Pulse', 'Waveflow'];

export const ctType = [null, '', 'ESP Supplied', 'Existing'];

export const ctSupplied = [
  null,
  '',
  '1600:5A, 22.5mm round bore, MBS AS Range CTs - Din Rail, Foot or Bar Mount, Class 1',
  "200/5A Split Core CT's",
  "300/5A Split Core CT's",
  "400/5A Split Core CT's",
  'Flexible Magnelab Three-Phase RopeCT RCS-1800-1000A',
  'Flexible Magnelab Three-Phase RopeCT RCS-1800-1500A',
  'Flexible Magnelab Three-Phase RopeCT RCS-1800-2000A',
  'Flexible Magnelab Three-Phase RopeCT RCS-1800-2500A',
  'Flexible Magnelab Three-Phase RopeCT RCS-1800-800A',
  'Size 1 - Split Core Voltage CTs - 100A (5m twisted lead)',
  'Size 1 - Split Core Voltage CTs - 150A (5m twisted lead)',
  'Size 1 - Split Core Voltage CTs - 50A (5m twisted leads)',
  'Size 2 - Split Core Voltage CTs - 100A (5m twisted lead)',
  'Size 2 - Split Core Voltage CTs - 200A (5m twisted lead)',
  'Size 2 - Split Core Voltage CTs - 250A (5m twisted lead)',
  'Size 2 - Split Core Voltage CTs - 400A (5m twisted lead)',
  'Size 2 - Split Core Voltage CTs - 600A (5m twisted lead)',
  'Size 3 - Split Core Voltage CTs 400A (5m twisted lead)',
  'Size 3 - Split Core Voltage CTs 600A (5m twisted lead)',
  'Size 3 - Split Core Voltage CTs 800A (5m twisted lead)',
  'Size 4 - Split Core Voltage CTs 1000A (5m twisted lead)',
  'Size 4 - Split Core Voltage CTs 2000A (5m twisted Lead)',
  "Size 4 - Split Core Voltage CT's 800 Amp (5m twisted lead)",
  'Teardrop Magnelab Three-Phase Rope CT RCS-350T-1000A',
  'Teardrop Magnelab Three-Phase Rope CT RCS-350T-2000A',
  'Teardrop Magnelab Three-Phase Rope CT RCS-350T-500A',
];

export const metersSupplied = [
  null,
  '',
  '80 amp Single phase whole current meter with modbus',
  'Cat 1 Meter Supply and Install',
  'Cat 2 Meter Supply and Install',
  'Cat 3 Meter Supply and Install',
  'eGauge Pro',
  'EiFlex 10 (Master unit plus 5 slaves)',
  'EiFlex 12 (Master unit plus 6 slaves)',
  'EiFlex 14 (Master unit plus 7 slaves)',
  'EiFlex 16 (Master unit plus 8 slaves)',
  'EiFlex 18 (Master unit plus 9 slaves)',
  'EiFlex 4 (Master Unit plus 2 slaves)',
  'EiFlex 6 (Master unit plus 3 slaves)',
  'EiFlex 8 (Master unit plus 4 slaves)',
  'Kent Water Meter 20mm PSM-T',
  'Kent Water Meter 25mm PSM-T',
  'Kent Water Meter 40mm PSM-T',
  'Kent Water Meter Helix 4000 100mm',
  'Kent Water Meter Helix 4000 80mm',
  'Meter -3 Phase Direct Read kWh Meter 100A M/Bus',
  'Meter LP3KW4C -3 phase kWh meter with pulse output - unbalanced load',
  'Meter LP3KW4M Modbus 3 phase kWh CT meter - unbalanced load',
  'Northern Design 5 amp cube meter',
  'Northern Design Cube 350 (Amp Input)',
  'Northern Design Cube 350 (MV Input)',
  'Northern Design Rail 350 (AMP input)',
  'Northern Design Rail-350 (MV Input)',
  'PSTM 25mm Water Meter',
  'Siemens Mag5000 150mm with M5100',
  'Single phase 100 Amp direct read meter RS485 Modbus',
  'Temperature & Humidity Sensor industrial',
  'Ultraflow U1000 Flow meter',
  'Ultraflow U1000 Heat meter',
  'Woltman Water Meter 50mm',
];

export const uomTypes = [
  null,
  '',
  'Bar',
  'Baseline kWh',
  'Baseline m3',
  'Binary',
  'Cans',
  'CDD for 14C',
  'CDD for 16C',
  'CDD for 18C',
  'CDD for -5C',
  'Count',
  'Days',
  'Degrees Celsius',
  '$/Gas kWh',
  'Gas kWh',
  'GasNorm m3',
  'GasRaw m3',
  'Generated kVAh',
  'Generated kVArh',
  'Generated kWh',
  'GJ',
  'MJ',
  'HDD for 18C',
  'Hours',
  'Hz',
  'Joules',
  'kg/kWh',
  'kgs',
  'kVa',
  'kVA',
  'kVAh',
  'kVAr',
  'kVArh',
  'kW',
  'kWh',
  '$/kWh',
  'L1A',
  'L1A Max',
  'L1V',
  'L2A',
  'L2A Max',
  'L2V',
  'L3A',
  'L3A Max',
  'L3V',
  'Litres per second',
  'Metres',
  'Minutes',
  'NONE',
  'Occupancy',
  'on/off',
  'Pascals',
  'Power Factor',
  'Predicted kWh',
  'Predicted m3',
  'PUE',
  'Ratio',
  'Reduction Target kWh',
  'Reduction Target m3',
  'Relative Humidity',
  'RH (Relative Humidity)',
  'Square Metres',
  'Thermal kWh',
  'Tonnes',
  'Unknown',
  'VoltsA',
  'VoltsB',
  'VoltsC',
  '$/Water m3',
  'Water m3',
];

export const functionalUses = [
  { label: '', value: 0 },
  { label: 'Industrial', value: 1 },
  { label: 'Data Center', value: 2 },
  { label: 'Hotel / Motel', value: 3 },
  { label: 'Manufacturing', value: 4 },
  { label: 'Office Building', value: 5 },
  { label: 'Car Park', value: 6 },
  { label: 'Education', value: 7 },
  { label: 'Healthcare', value: 8 },
  { label: 'Residential', value: 9 },
  { label: 'Library', value: 10 },
  { label: 'Public Pool', value: 11 },
  { label: 'Public Assembly', value: 12 },
  { label: 'Other', value: 13 },
  { label: 'None', value: 100 },
];

export const heatSystems = [
  { label: '', value: 0 },
  { label: 'Coal / Fuel Oil', value: 1 },
  { label: 'Electric Resistive', value: 2 },
  { label: 'Electric Heat Pump', value: 3 },
  { label: 'Gas', value: 4 },
  { label: 'Bio Fuel', value: 5 },
  { label: 'None', value: 100 },
];

export const coolingSystems = [
  { label: '', value: 0 },
  { label: 'Heatpump', value: 1 },
  { label: 'Chiller - Water Cooled', value: 2 },
  { label: 'Chiller - Air Cooled', value: 3 },
  { label: 'Chiller - Hydronic', value: 4 },
  { label: 'Bio Fuel', value: 5 },
  { label: 'None', value: 100 },
];

export const ratingTypes = [
  { label: '', value: 0 },
  { label: 'GREENSTAR', value: 1 },
  { label: 'NABERSNZ', value: 2 },
  { label: 'LEED', value: 3 },
];

export const weatherStations = [
  { label: 'Auckland Aiport', value: 1 },
  { label: 'Manukau', value: 2 },
  { label: 'Wellington', value: 3 },
  { label: 'Somewhere else', value: 4 },
];

export const unitToSummationType = {
  Bar: 'AVG',
  Binary: 'AVG',
  'Degrees Celsius': 'AVG',
  Hz: 'AVG',
  'kg/kWh': 'AVG',
  kVa: 'AVG',
  kVAr: 'AVG',
  kW: 'AVG',
  L1A: 'AVG',
  'L1A Max': 'AVG',
  L1V: 'AVG',
  L2A: 'AVG',
  'L2A Max': 'AVG',
  L2V: 'AVG',
  L3A: 'AVG',
  'L3A Max': 'AVG',
  L3V: 'AVG',
  'Litres per second': 'AVG',
  Occupancy: 'AVG',
  'on/off': 'AVG',
  Pascals: 'AVG',
  'Power Factor': 'AVG',
  PUE: 'AVG',
  Ratio: 'AVG',
  'RH (Relative Humidity)': 'AVG',
  VoltsA: 'AVG',
  VoltsB: 'AVG',
  VoltsC: 'AVG',
  'Baseline kWh': 'SUM',
  'Baseline m3': 'SUM',
  Cans: 'SUM',
  'CDD for 14C': 'SUM',
  'CDD for 16C': 'SUM',
  'CDD for 18C': 'SUM',
  'CDD for -5C': 'SUM',
  Count: 'SUM',
  Days: 'SUM',
  'Gas kWh': 'SUM',
  'GasNorm m3': 'SUM',
  'GasRaw m3': 'SUM',
  'Generated kVAh': 'SUM',
  'Generated kVArh': 'SUM',
  'Generated kWh': 'SUM',
  GJ: 'SUM',
  MJ: 'SUM',
  'HDD for 18C': 'SUM',
  Hours: 'SUM',
  Joules: 'SUM',
  kgs: 'SUM',
  kVAh: 'SUM',
  kVArh: 'SUM',
  kWh: 'SUM',
  Metres: 'SUM',
  Minutes: 'SUM',
  NONE: 'SUM',
  'Predicted kWh': 'SUM',
  'Predicted m3': 'SUM',
  'Reduction Target kWh': 'SUM',
  'Reduction Target m3': 'SUM',
  'Relative Humidity': 'SUM',
  'Square Metres': 'SUM',
  'Thermal kWh': 'SUM',
  Tonnes: 'SUM',
  Unknown: 'SUM',
  'Water m3': 'SUM',
};

export const statusLabels: { [key in NotificationsStatusEnum]: string } = {
  [NotificationsStatusEnum.Pending]: 'Pending',
  [NotificationsStatusEnum.Disqualified]: 'Disqualified',
  [NotificationsStatusEnum.Qualified]: 'Qualified',
  [NotificationsStatusEnum.Ignored]: 'Ignored',
  [NotificationsStatusEnum.Investigating]: 'Investigating',
  [NotificationsStatusEnum.WorkInProgress]: 'WIP',
  [NotificationsStatusEnum.Resolved]: 'Resolved',
  [NotificationsStatusEnum.QualifiedNotify]: 'Qualified Notify',
  [NotificationsStatusEnum.QualifiedSuppressed]: 'Qualified Suppressed',
  [NotificationsStatusEnum.BraveGenInvestigating]: 'BraveGen Investigating',
};
